import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

export function useWeather() {
  return useQuery({
    queryKey: ['weather'],
    queryFn: api.getWeather,
    staleTime: 5 * 60_000,
    refetchInterval: 10 * 60_000,
  })
}
